/**
 * One way to turn a failed request into words for kitchen and store staff
 * (pilot fix, Batch 5 lane tablet). Staff used to see transport text such as
 * "timeout of 30000ms exceeded" or "Network Error".
 *
 *  - no response (offline, timeout) → "No connection…" — or, when the action
 *    was saved on the tablet, that it will be sent when the tablet is back
 *    online;
 *  - a server error (5xx) → "Something went wrong on our side. Try again.";
 *  - anything else the server refused (4xx) keeps the server's own message,
 *    which is written for staff ("Only 2 kg was sent").
 */
import { T } from './strings'

interface ErrorLike {
  message?: unknown
  status?: unknown
  isNetworkError?: unknown
}

/** Transport text axios / the browser produce when there was no answer. */
const TRANSPORT_TEXT = /^(network error|timeout of \d+ms exceeded|request aborted|failed to fetch|load failed)$|ECONNABORTED|ERR_NETWORK/i

/** brief: only the server message's first part ("… — details" drops the details). */
export function friendlyError(err: unknown, opts: { queued?: boolean; brief?: boolean } = {}): string {
  const e = (err && typeof err === 'object' ? err : {}) as ErrorLike
  const message = typeof e.message === 'string' ? e.message.trim() : ''
  const status = typeof e.status === 'number' ? e.status : undefined
  const noAnswer = e.isNetworkError === true || (status === undefined && TRANSPORT_TEXT.test(message))
  if (noAnswer) return opts.queued ? T.errOfflineQueued : T.errOffline
  if (status !== undefined && status >= 500) return T.errServer
  // axios's own text when the server sent no message of its own.
  if (!message || TRANSPORT_TEXT.test(message) || /^Request failed with status code \d+$/i.test(message)) return T.errGeneric
  return opts.brief ? message.split(' — ')[0] : message
}
